//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Preferences.js";
import "../no/Object.js";
import "../Preferences/Preferences.ViewPreferences.js";
let d=[[[0,"AngleDecimalPointFormat",1,0],[0,"AngleFormat",1,0],[0,"AnglePrecision",1,0],[0,"AutomaticAnchorPoint",1,0],[0,"AutomaticUpdate",1,0],[0,"BoundaryStatus",1,0],[0,"Centerlines",1,0],[0,"DisplayId",1,0],[0,"ExtractedEdges",1,0],[0,"FramebarHorizontal",1,1],[0,"FramebarVertical",1,1],[0,"LegacyView",1,0],[0,"LightweightView",1,0],[0,"LockmethodView",1,0],[0,"Reference",1,0],[0,"ShowAngleLeadingZeros",1,0],[0,"ShowAngleTrailingZeros",1,0],[0,"Silhouettes",1,0],[0,"SnapshotView",1,1],[0,"Tolerance",1,0],[0,"UvGrid",1,0],[0,"ViewQuality",1,0],[0,"ViewRepresentation",1,0],[0,"WireframeColorSource",1,0]],[],[["FrameBar","Preferences.FrameBarPreferences",0]]];
SPLM.Preferences.GeneralViewPreferences = class extends SPLM.Object{
    constructor (owner){
        if(owner !== undefined){
            if(owner._owner !== undefined){
                super(owner._owner);
                this._owner = owner._owner;
            }
            else{
                super(owner);
                this._owner = owner;
            }
            this._d['ObjectId'] = this._owner._d['ObjectId'];
        }
        else{
            super();
        }
        this._d['Class'] = "SPLM.Preferences.GeneralViewPreferences";
        SPLM.c$d(this.Class,d);d=[];
    }
};

export default SPLM;